module.exports = __webpack_public_path__ + "static/media/Calender_Meeting_Invite_Video.c6d6986f.mp4";